<template>
  <div class="content my-bonus-info">
    <h3>{{ $t("Bao.news") }}</h3>
    <div class="news-list">
      <div
        v-for="(item, index) in marqueeDetails.filter(item => item.isShow)"
        ref="newsItems"
        :key="index"
        :class="{active: activeIndex === index}"
        class="news-item"
      >
        <div class="news-info" @click="showDetail(index)">
          <i />
          <!-- eslint-disable-next-line -->
          <div class="title" v-html="item.title"></div>
        </div>
        <!-- eslint-disable-next-line -->
        <div class="news-box" v-html="item.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { detectMob } from '@/utils/tool'

export default {
  data() {
    return {
      activeIndex: null
    }
  },
  computed: {
    marqueeDetails() {
      return this.$store.state.brand.marqueeDatail
    }
  },
  created() {
    // Now call the method to filter items
    this.showMarqueeInfos()

    if (this.$store.state.user.newsIndex) {
      this.activeIndex = this.$store.state.user.newsIndex - 1
      this.scrollPage()
      this.$store.commit('SET_CHOOSE_NEWS', null)
    }
  },
  methods: {
    showDetail(index) {
      this.activeIndex = this.activeIndex === index ? null : index
      this.scrollPage()
    },
    showMarqueeInfos() {
      const userVipLevel = this.$store.state.user.memberInfo ? this.$store.state.user.memberInfo.vip_level_id : null
      const userMemberLevel = this.$store.state.user.memberInfo ? this.$store.state.user.memberInfo.vl : null
      this.marqueeDetails.forEach(item => {
        item.isShow = false
        if (!item.setting || !item.setting.allow_vip_levels || !item.setting.allow_member_levels) {
          item.isShow = true
          return
        }
        const allowedVipLevels = item.setting.allow_vip_levels
          .split(',')
          .map(s => s.trim())
          .filter(s => s)
          .map(Number)

        const allowedMemberLevels = item.setting.allow_member_levels
          .split(',')
          .map(s => s.trim())
          .filter(s => s)
          .map(Number)
        if (allowedVipLevels.includes(userVipLevel) &&
        allowedMemberLevels.includes(userMemberLevel)) {
          item.isShow = true
        }
      })
    },
    scrollPage() {
      this.$nextTick(() => {
        if (this.activeIndex !== null) {
          const activeItem = this.$refs.newsItems[this.activeIndex]

          if (activeItem) {
            let itemOffset = activeItem.getBoundingClientRect().top + window.scrollY
            if (detectMob()) {
              if (this.$store.getters.token) {
                itemOffset = itemOffset - 70
              } else {
                itemOffset = itemOffset - 120
              }
            }

            window.scrollTo({
              top: itemOffset,
              behavior: 'smooth'
            })
          }
        }
      })
    }
  }
}
</script>
